import { useState, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Select, Button, message, Tooltip } from 'antd';
import moment from 'moment-timezone';
import * as _ from 'lodash';
import { saveForecastPrediction } from '../../../services/reservation';
import SymbolsClass from './SymbolsClass';

const ForecastList = ({
	forecastData, forecast, index
}) => {
	const location = useLocation();
	const { t } = useTranslation();
	const { Option } = Select;
	const [refresh, setRefresh] = useState(false);

	const handleAttendanceChange = (field, reservation_id, patient_id, value) => {
		if (value) {
			let _newState = {
				'reservationId': reservation_id,
				'patientId': patient_id,
				'newState': value,
			};

			const index = forecastData.data.findIndex((data) =>
				data.patient_id === patient_id && data.reservation_id === reservation_id);
			forecastData.data[index].assistance_state = value
			doSaveForecastPrediction(_newState);
		}
	}

	const doSaveForecastPrediction = async (newState) => {
		try {
			await saveForecastPrediction(newState);
			setRefresh(moment().unix());
		} catch (err) {
			message.error("Error al guardar")
			console.error(err)
		}
	}

	return (
		<Row
			className="table-body mb-lg-10 mb-md-15 mb-sm-15 mb-xs-15"
			key={index}
		>
			<Col lg={3} xs={12} className="table-body__item">
				<p className="text-center mb-0 ml-15">
					{forecast.reservation_number}
				</p>
			</Col>
			<Col lg={3} xs={12} className="table-body__item">
				<p className="text-center mb-0">
					{forecast.patient_name}
				</p>
			</Col>
			<Col lg={2} xs={12} className="table-body__item">
				<p className="text-center mb-0">
					{forecast.branch_office}
				</p>
			</Col>
			<Col lg={3} xs={12} className="table-body__item">
				<Tooltip
					overlayClassName='see-services-tooltip'
					trigger="click"
					color="#FFFFFF"
					title={
						<Fragment>
							<Row justify="space-between">
								<Col lg={15}>
									<p className="title mb-10">
										{t("reservations.forecast.serviceTitle")}
									</p>
								</Col>
								<Col lg={9}>
									<p className="title mb-10">
										{t("reservations.forecast.block")}
									</p>
								</Col>
							</Row>
							<Fragment>
								{forecast?.prestations?.map((services) => {
									return (
										<Row justify="space-between" key={services.prestation_id}>
											<Col lg={15}>
												<p>{services.exam_name}</p>
											</Col>
											<Col lg={9}>
												<p>{services.blockTime}hs</p>
											</Col>
										</Row>
									)
								})}
							</Fragment>
						</Fragment>
					}
				>
					<p
						className="disabled text-center mb-0"
						style={{ cursor: "pointer" }}
					>
						Ver
					</p>
				</Tooltip>
			</Col>
			<Col lg={3} xs={12} className="table-body__item">
				<p className="text-center mb-0">
					{forecast.reservation_date}
				</p>
			</Col>
			<Col lg={3} xs={12} className="table-body__item">
				{forecast.assistance_state === "will_attend" || forecast.assistance_state === "will_not_attend" ?
					<p className="text-center-green mb-0">
						{forecast.phone}
					</p>
					:
					<p className="text-center mb-0">
						{forecast.phone}
					</p>
				}
			</Col>
			<Col lg={3} xs={12} className="table-body__item">
				<Select
					className='cmt-select'
					value={forecast.assistance_state}
					onChange={(value) => handleAttendanceChange('attendance', forecast.reservation_id, forecast.patient_id, value)}
					size="small"
					style={{ width: '135px', fontSize: '14px' }}
					placeholder={t("reservations.forecast.attendancePlaceholder")}
				>
					<Option value="not_contacted">
						<p className>{t("reservations.forecast.notContacted")}</p>
					</Option>
					<Option value="will_attend">
						<p>{t("reservations.forecast.willAttend")}</p>
					</Option>
					<Option value="will_not_attend">
						<p>{t("reservations.forecast.willNotAttend")}</p>
					</Option>
				</Select>
			</Col>
			<Col lg={2} xs={12} className="table-body__item">
				<Row className="symbols-key">
					{SymbolsClass(forecast.predict_percent)}
				</Row>
			</Col>
			<Col lg={2} xs={12} className="table-body__item">
				<Link
					to={{
						pathname: `/reservas/${forecast.reservation_id}/ver`,
						state: {
							from: location.pathname,
							search: location.search,
						},
					}}
					style={{ width: "80%" }}
					className="mr-lg-15"
				>
					<Button
						className="cmt-button secondary outline ml-10 mr-10"
						type="primary"
						size="small"
					>
						Ver más
					</Button>
				</Link>
			</Col>
		</Row>
	)
}

export default ForecastList;
